import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';
import type { UpdateBitwerxOfferingPayload } from '@v2/types';

export const useUpdateBitwerxOffering = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      offeringId,
      payload,
    }: {
      offeringId: string;
      payload: UpdateBitwerxOfferingPayload;
    }) => offeringsService.updateBitwerxOffering(offeringId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.offerings.bitwerx.all);
    },
  });

  const updateBitwerxOffering = async (
    offeringId: string,
    payload: UpdateBitwerxOfferingPayload,
  ): Promise<unknown> => {
    if (!offeringId?.trim()) return null;
    try {
      return await mutation.mutateAsync({ offeringId, payload });
    } catch {
      return null;
    }
  };

  return {
    updateBitwerxOffering,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useUpdateBitwerxOffering;
